import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Table from './components/table/Table.vue'
import Drawer from './components/elements/Drawer.vue'
import Select from './components/elements/Select.vue'
import { Datetime } from 'vue-datetime'

import './scss/index.scss'

Vue.config.productionTip = false
Vue.component('datetime', Datetime);
Vue.component('Table', Table)
Vue.component('Drawer', Drawer)
Vue.component('Select', Select)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
